// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__19Rec","actionsCol":"EnrolledClinics_actionsCol__39ohm"};